import ViewSwitcher from '@anm/components/ViewSwitcher';
import CardModal from '@anm/components/modals/CardModal';
import { useState, FC } from 'react';

import { CancelSubscriptionModalWrapper } from './Wrapper';
import BenefitsStep from './components/BenefitsStep';
import ReasonStep from './components/ReasonStep';
import StarterStep from './components/StarterStep';

type CancelSubscriptionModalProps = {
  planName: string;
  isCancelPending: boolean;
  isKeepPending: boolean;
  onClose: () => void;
  onCancel: () => void;
  onBuyStarter: () => void;
  error?: string;
};

const BENEFITS_STEP = 0;
const REASON_STEP = 1;
const STARTER_STEP = 2;

type Steps = typeof BENEFITS_STEP | typeof REASON_STEP | typeof STARTER_STEP;
const CancelSubscriptionModal: FC<CancelSubscriptionModalProps> = ({
  error,
  planName,
  isCancelPending,
  isKeepPending,
  onBuyStarter,
  onClose,
  onCancel
}) => {
  const [currentStep, setCurrentStep] = useState<Steps>(BENEFITS_STEP);

  return (
    <CardModal onModalClose={onClose} isCloseButtonInsideModal={true} cardSettings={{ isPadding: false }}>
      <CancelSubscriptionModalWrapper>
        <ViewSwitcher active={currentStep}>
          <BenefitsStep onKeep={onClose} onCancel={() => setCurrentStep(REASON_STEP)} />
          <ReasonStep onKeep={onClose} onCancel={() => setCurrentStep(STARTER_STEP)} />
          <StarterStep
            {...{ planName, isCancelPending, isKeepPending, error, onCancel }}
            onKeep={onClose}
            onStarter={onBuyStarter}
          />
        </ViewSwitcher>
      </CancelSubscriptionModalWrapper>
    </CardModal>
  );
};

export default CancelSubscriptionModal;
